import { callServiceAPI } from './ApiUtils';

// Hand-written (not engine generated) calls to the orderservices microservice.

// Submits an order for MD approval: starts the approval workflow for each live product and tells the MD.
// Refuses (with a message) when a product's price or the order value does not add up - the order stays in DRAFT
// and can be edited and submitted again.
export function submitOrderForApprovalAPI(payload, successCallBack, failuerCallback){
    callServiceAPI("https://api.mypharmafactory.com/orderservices/submitorderformdapproval", "POST", payload, successCallBack, failuerCallback);
}
